<template>
  <div v-bind="$attrs" class="columns is-multiline flex--justify-center">
    <div
      class="column"
      :class="columnClass" 
      v-for="(material, i) in visibleMaterials"
      :key="`material-${i}`">

      <template v-for="(item, i) in template">

        <component
          class="word-wrap"
          :key="item.label + '-' + i"
          :is="item.tag"
          v-if="item.tag != 'img'">
          {{ material[item.label] }}
        </component>

        <img
          class="exception my-2"
          v-if="item.tag == 'img' && material[item.label].url"
          :key="item.label + '-' + i"
          :src="material[item.label].url"/>

      </template>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    template: {
      type: Array
    },
    materials: {
      type: Array
    }
  },
  computed: {
    visibleMaterials({ materials }) {
      return materials.filter(d => d.visible == true)
    },
    columnClass({ visibleMaterials }) {
      if (visibleMaterials.length == 1) {
        return 'flex flex--column flex--align-center is-half has-text-centered'
      } else if (visibleMaterials.length < 3) {
        return 'flex flex--column flex--align-center has-text-centered'
      } else {
        return 'flex flex--column flex--align-center is-one-third has-text-centered'
      }
    }
  }
}
</script>


<style scoped lang="scss">
@import '@/styles/flexbox.scss';

.word-wrap {
  word-wrap: break-word;
  display: block;
  white-space: normal;
  width: 100%;
}

h3, p {
  font-size: 0.8em !important;
}
</style>